// extracted by mini-css-extract-plugin
export default {"wrapper":"EventPage_wrapper__PMU-C","eventInner":"EventPage_eventInner__lPSDn"};